import config from '../config';
import trainTime from '../lib/TrainTime';
import { translate as t, hasMessage } from '../lib/I18n';
import FeatureFlagStore from '../stores/FeatureFlagStore';

export function isUpdatedRefundCopyEnabled() {
    return FeatureFlagStore.get('enableUpdatedRefundCopy');
}

export function getUpdatedRefundCopyDayScope(fare, enableUpdatedRefundCopy = isUpdatedRefundCopyEnabled()) {
    if (!enableUpdatedRefundCopy) {
        return null;
    }

    return trainTime.isToday(fare.getValidFrom()) ? 'today' : 'notToday';
}

export function getUpdatedRefundCopyScopedMessage(baseMessageKey, fare, options = {}) {
    const { enableUpdatedRefundCopy, fallbackToBase = true } = options;
    const dayScope = getUpdatedRefundCopyDayScope(fare, enableUpdatedRefundCopy);

    if (!dayScope) {
        return fallbackToBase ? baseMessageKey : null;
    }

    return `${baseMessageKey}.${dayScope}`;
}

export function getTicketTypeRefundDescriptionMessageKey(fare, options = {}) {
    const groupKey = fare.isAnytime() ? 'anytime' : fare.isOffPeak() ? 'offpeak' : null;
    const scopedKey = groupKey && getUpdatedRefundCopyScopedMessage(`tickettype.${groupKey}`, fare, {
        ...options,
        fallbackToBase: false
    });

    return scopedKey || `tickettype.${fare.ticketType.code}`;
}

export function getTicketTypeRefundDescription(fare, options = {}) {
    const key = getTicketTypeRefundDescriptionMessageKey(fare, options);
    return hasMessage(key) ? t(key) : null;
}

export function getFareRefundDetailsMessageKey(fare, enableUpdatedRefundCopy) {
    const brand = config.get('brand');
    const scoped = (baseKey) => getUpdatedRefundCopyScopedMessage(`booking.fareDetails.refunds.${enableUpdatedRefundCopy ? 'small' : baseKey}`, fare, {
        enableUpdatedRefundCopy
    });

    if (fare.isRoversRangers()) {
        return '';
    }

    if (fare.isFlexi()) {
        return 'booking.fareDetails.refunds.flexiTicket';
    }

    if (fare.isSeason()) {
        return 'booking.fareDetails.refunds.seasonTicket';
    }

    if (fare.isAdvance() && fare.origin && fare.origin.crs === 'MIA' && brand === 'transpennine') {
        return 'booking.fareDetails.refunds.MIAadvanceTicket';
    }

    if (fare.isAdvance()) {
        return 'booking.fareDetails.refunds.advanceTicket';
    }

    if (fare.isDaySaveOffPeak()) {
        return 'booking.fareDetails.refunds.daySaveOffPeak';
    }

    if (fare.isAnytime() && fare.hasRailcard()) {
        return scoped('dayTicket.railcard');
    }

    if (fare.isTPEStaffRover()) {
        return 'booking.fareDetails.refunds.staffRoverTicket';
    }

    return scoped('dayTicket');
}
